import UrlsConstants from '../constants/UrlsConstants'
import ActionsConstants from '../constants/ActionsConstants'
import MethodsWSConstants from '../constants/MethodsWSConstants'
import AuthConstants from '../constants/AuthConstants'
import RoutesConstants from '../constants/RoutesConstants'
import AppsConstants from '../constants/AppsConstants'
import RegExConstants from '../constants/RegExConstants'
import ToursConstants from '../constants/ToursConstants'

export default {
  UrlsConstants,
  ActionsConstants,
  MethodsWSConstants,
  RoutesConstants,
  AuthConstants,
  AppsConstants,
  RegExConstants,
  ToursConstants,
  langs: [
    'fr',
    'en',
  ],
  supportedLangs: [
    'fr',
    'en',
  ],
  os: [
    'ANDROID',
    'IOS',
  ]
}
